import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {WinMeterEvents} from '@gongxigames/framework/slot/modules/winmeter';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {PickBonusEvents} from '@gongxigames/framework/slot/modules/pick';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {WinPresentationViewEvents} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationViewEvents';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationEvents';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';

export class WinPresentationFreeSpinsInitialState extends ModuleState<WinPresentationView, WinPresentationModule> {

    public onEnterState(): void {
        this.emit(WinMeterEvents.STOP_FINAL_VALUE_TIMER);
        this.module.winMeterFinished = false;
        this.module.allPaysAnimationsFinished = false;
        this.module.play(true);
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(
            WinPresentationViewEvents.INITIAL_ANIMATION_FREESPINS_FINISHED,
            this.onInitialAnimationFreeSpinsFinished.bind(this)
        );
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(BigWinEvents.FINISHED, this.onBigWinFinished.bind(this));
        this.setEventHandler(PickBonusEvents.FINISHED, this.onPickBonusFinished.bind(this));
        this.setEventHandler(PickBonusEvents.STARTED, this.onPickBonusStarted.bind(this));
        this.setEventHandler(FlowModuleEvents.SHOULD_START_INDIVIDUAL_WIN_FREESPINS, this.onFlowShouldStartIndividualWin.bind(this));
        this.setEventHandler(GenericPopupEvents.POPUP_CLOSED, this.onPopupClosed.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
    }

    protected onPopupClosed(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_OUTRO) {
            this.onFreeSpinOutro();
        }
    }

    protected onPopupStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_RETRIGGER) {
            this.onRetriggerStarted();
        }
    }

    protected onBigWinFinished(): void {
        if (this.module.isIndividualWinMustBePaused) {
            this.module.isIndividualWinMustBePaused = false;
        }
        this.module.gotoState(WinPresentationModule.FREESPINS_PAYS_STATE);
    }

    protected onPickBonusFinished(): void {
        if (!this.module.isIndividualWinMustBePaused) {
            this.module.gotoState(WinPresentationModule.FREESPINS_PAYS_STATE);
        }
    }

    protected onPickBonusStarted(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }

    protected onRetriggerStarted(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }

    protected onReelsSpinningStarted(): void {
        this.module.stopInFreeSpins();
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }

    protected onFreeSpinOutro(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }

    protected onInitialAnimationFreeSpinsFinished(): void {
        this.emit(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
    }

    protected onFlowShouldStartIndividualWin(): void {
        this.module.gotoState(WinPresentationModule.FREESPINS_PAYS_STATE);
    }

    protected onSpinButtonPressed(): void {
        this.module.stopInFreeSpins();
        this.onInitialAnimationFreeSpinsFinished();
        this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
    }
}
